import { useLazyQuery } from "@apollo/client";
import { GET_UNITS } from "../../graphql/unit/query";
import _ from "lodash";

export const useQueryUnitData = () => {
    // apollo client hooks
    const [getUnitData, { data: loadUnitData, loading: loadingUnitDatas, error }] = useLazyQuery(GET_UNITS, {
        fetchPolicy: "cache-and-network",
    });

    // localStorage data
    const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"))

    // unit datas
    const queryUnitDatas = async ({ _name }) => {
        try {
            let _where = {
                shop: shopData?.id,
                isDeleted: false,
            }
            if (!_.isEmpty(_name)) {
                _where = {
                    ..._where,
                    name: _name
                }
            }
            await getUnitData({
                variables: {
                    where: _where,
                }
            });
            if (error) {
                return { error: true, message: `Query Unit Data Error: ${error.message}` };
            }
            return { data: loadUnitData };
        } catch (error) {
            return { error: true, message: `Query Unit Data Error: ${error.message}` };
        }
    };

    return {
        queryUnitDatas,
        loadUnitData,
        loadingUnitDatas,
        error,
    };
};
